import { render, staticRenderFns } from "./hotJobvAcancies.vue?vue&type=template&id=36314698&scoped=true"
import script from "./hotJobvAcancies.vue?vue&type=script&lang=js"
export * from "./hotJobvAcancies.vue?vue&type=script&lang=js"
import style0 from "./hotJobvAcancies.vue?vue&type=style&index=0&id=36314698&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36314698",
  null
  
)

export default component.exports